import type { tokenResponseSchema } from "@/api/backoffice/login/backoffice-login-api.ts";
import type { z } from "zod";

export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = "access_token";
export const REFRESH_TOKEN_LOCAL_STORAGE_KEY = "refresh_token";
export const EXPIRES_IN_LOCAL_STORAGE_KEY = "expires_in";

export function saveTokenDetailsInLocalStorage(tokenDetails: z.infer<typeof tokenResponseSchema>) {
  localStorage.setItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY, tokenDetails.access_token);
  localStorage.setItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY, tokenDetails.refresh_token);
  localStorage.setItem(EXPIRES_IN_LOCAL_STORAGE_KEY, `${tokenDetails.expires_in}`);
}

export function retrieveTokenDetailsFromLocalStorage(): z.infer<typeof tokenResponseSchema> | undefined {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);
  const expiresIn = localStorage.getItem(EXPIRES_IN_LOCAL_STORAGE_KEY);

  if (!accessToken || !refreshToken || !expiresIn) {
    return undefined;
  }

  return {
    refresh_token: refreshToken,
    access_token: accessToken,
    expires_in: +expiresIn,
  };
}

export function clearTokenDetailsFromLocalStorage() {
  localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
  localStorage.removeItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);
}
